module.exports = __webpack_public_path__ + "img/chlothes.1474e1a7.jpg";